import { render, staticRenderFns } from "./drag-verify.vue?vue&type=template&id=3a42cee2"
import script from "./drag-verify.vue?vue&type=script&lang=js"
export * from "./drag-verify.vue?vue&type=script&lang=js"
import style0 from "./drag-verify.vue?vue&type=style&index=0&id=3a42cee2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports